import type { CampaignStatus } from '~/types/graphql';

import { getCampaignStatusInfo } from '../../helpers/campaign';
import { useTranslation } from 'react-i18next';
import { GTooltip } from '~/presentation/ui';

interface IProps {
  campaignName?: string;
  campaignStatus?: CampaignStatus;
}

/** Help text naming the experiment a resource is locked by, e.g. "In Draft experiment". */
export const CampaignHelpText: React.FC<IProps> = ({ campaignName, campaignStatus }) => {
  const { t } = useTranslation();
  const { name: statusName, customColor } = getCampaignStatusInfo(campaignStatus);

  return (
    <div className="flex items-center gap-1">
      {t('In')}
      <span className="font-[550]" style={{ color: customColor }}>
        {t(statusName)}
      </span>
      <GTooltip content={campaignName}>
        <span className="underline decoration-dotted decoration-[#b5b5b5]">{t('experiment')}</span>
      </GTooltip>
    </div>
  );
};
